import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { MUTATION_EDIT_SETTING } from "../../../service/ApolloClient/ApolloMutation";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";

const SettingEdit = (props) => {
  const [value, setValue] = React.useState(props.data.value);
  const [loading, setLoading] = React.useState(false);

  const handleSave = () => {
    setLoading(true);

    client
      .mutate({
        mutation: MUTATION_EDIT_SETTING,
        variables: {
          id: parseInt(props.data.id),
          value,
        },
      })
      .then((res) => {
        if (res.data.editSetting) {
          SuccessToast("با موفقیت تنظیمات ویرایش شد");
          props.history.push("/settings/list");
        } else {
          ErrorToast("مشکلی در ثبت رخ داده است");
        }
      })
      .catch((err) => {
        console.log(err.message);
        ErrorToast("قادر به ثبت نمی باشد");
      });
  };

  return (
    <Card>
      <CardContent>
        <Box pr={2}>
          <Typography align={"left"} variant={"h6"}>
            ویرایش تنظیمات
          </Typography>
        </Box>
        <Box p={1}>
          <Grid xs={12}>
            <TextFieldHelper
              disabled={true}
              fieldName={"name"}
              values={{ name: props.data.name }}
              touched={{ name: false }}
              errors={{ name: false }}
            />
          </Grid>
        </Box>
        <Box p={1}>
          <Grid xs={12}>
            <TextFieldHelper
              disabled={true}
              fieldName={"name_persian"}
              values={{ name_persian: props.data.name_persian }}
              touched={{ name_persian: false }}
              errors={{ name_persian: false }}
            />
          </Grid>
        </Box>
        <Box p={1}>
          <TextFieldHelper
            disabled={false}
            fieldName={"value"}
            values={{ value: value }}
            touched={{ value: false }}
            errors={{ value: false }}
            multiline={true}
            handleChange={(e) => {
              setValue(e.target.value);
            }}
          />
        </Box>
        <Box p={1}>
          {loading ? (
            <LinearProgress />
          ) : (
            <Button
              onClick={handleSave}
              fullWidth={true}
              variant={"contained"}
              color={"primary"}
            >
              ثبت تغییرات
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default withRouter(SettingEdit);
